module.exports = __webpack_public_path__ + "static/speed-590b79411395670f876746267bce75a6.png";